import { forwardRef } from 'react';
import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { useCalculatorContext } from '../../contexts';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export var HeaderContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    dataTestId = _ref.dataTestId;
  var _useCalculatorContext = useCalculatorContext(),
    layoutType = _useCalculatorContext.layoutType;
  var isTablet = layoutType !== LAYOUT_TYPE.Desktop && layoutType !== LAYOUT_TYPE.DesktopSmall;
  var isMobile = layoutType === LAYOUT_TYPE.Mobile;
  return /*#__PURE__*/_jsx("div", {
    className: styles.header,
    "data-mobile": isMobile || undefined,
    "data-tablet": isTablet || undefined,
    ref: ref,
    "data-test-id": dataTestId,
    children: children
  });
});